import { Injectable } from "@angular/core";
import { CONTROL_TYPES } from "../../control-types";
import { isInArray } from "../../../../core/util/is-in-array";
import { FormHelper } from "../../../pages/form/form-helper";
import { FormControl, FormGroup } from "@angular/forms";
import { ControlType } from "../../../business-objects/control-type/control-type.model";
import { Control } from "../../../business-objects/control/control.model";
import { IRegLookupResultField, IRegLookupResults } from "./results.model";
import { isString } from "ionic-angular/util/util";
import { VasAppFacade } from "../../../services/vas-app-facade.service";

@Injectable()
export class RegLookupControlHelperService {

    protected controls: Array<Control>;
    protected controlTypes: Array<ControlType>;

    constructor(protected appFacade: VasAppFacade) {

        this.appFacade.objects.control.store
            .getAll()
            .subscribe(controls => this.controls = controls);

        this.appFacade.objects.controlType.store
            .getAll()
            .subscribe(controls => this.controlTypes = controls);
    }

    resultsToFormGroup(results: IRegLookupResults): FormGroup {

        const fg = {};

        Object.keys(results)
            .filter(key => results[key].length > 0)
            .forEach(key => {
                const resultField: IRegLookupResultField = results[key];
                try {
                    fg[key] = new FormControl(resultField[0].value);
                } catch (e) {
                    fg[key] = new FormControl("");
                }
            });

        return new FormGroup(fg);
    }

    updateFormGroup(source: FormGroup, target: FormGroup): void {

        Object.keys(source.controls).forEach(key => {

            let controlType: ControlType;
            const sourceFormControl = source.controls[key];
            const targetFormControl = FormHelper.findFormControl(key, target);

            if (!targetFormControl) {
                console.warn(`could not find formControl with name ${key}`);
                return;
            }

            try {
                controlType = this.getControlTypeByControlName(key);
            } catch (e) {
                console.warn(e);
                return;
            }

            if (!controlType) {
                return;
            }

            try {
                if (isInArray(controlType.name, [CONTROL_TYPES.SELECT])) {
                    const value = sourceFormControl.value;
                    targetFormControl.setValue(value);
                } else {
                    targetFormControl.setValue(sourceFormControl.value);
                }
                targetFormControl.markAsDirty();
            } catch (e) {
                targetFormControl.setValue(undefined);
                targetFormControl.markAsDirty();
            }
        });
    }

    getControlByName(name: string): Control {
        return this.controls.find(c => c.name === name);
    }

    getControlById(id: string): Control {
        return this.controls.find(c => c.id === id);
    }

    getControlTitleByName(name: string): string {

        const control = this.getControlByName(name);

        if (!control) {
            return "";
        }

        return control.title;
    }

    getControlTitleById(id: string): string {

        const control = this.getControlById(name);

        if (!control) {
            return "";
        }

        return control.title;
    }

    getControlTypeByControlName(name: string): ControlType {
        const control = this.getControlByName(name);

        if (!control) {
            throw new Error(`could not find control with name ${name}`);
        }

        return this.getControlTypeById(control.controlType);
    }

    getControlTypeById(id: string): ControlType {
        return this.controlTypes.find(ct => ct.id === id);
    }
}



// WEBPACK FOOTER //
// ./src/vas/controls/reglookup/form/reg-lookup-control-helper.service.ts